/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitoredObjectGroupReplaceAssetsUsers
 */
export interface MonitoredObjectGroupReplaceAssetsUsers {
    /**
     * 
     * @type {Array<number>}
     * @memberof MonitoredObjectGroupReplaceAssetsUsers
     */
    monitoredObjects: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof MonitoredObjectGroupReplaceAssetsUsers
     */
    users: Array<number>;
}

export function MonitoredObjectGroupReplaceAssetsUsersFromJSON(json: any): MonitoredObjectGroupReplaceAssetsUsers {
    return MonitoredObjectGroupReplaceAssetsUsersFromJSONTyped(json, false);
}

export function MonitoredObjectGroupReplaceAssetsUsersFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoredObjectGroupReplaceAssetsUsers {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'monitoredObjects': json['monitored_objects'],
        'users': json['users'],
    };
}

export function MonitoredObjectGroupReplaceAssetsUsersToJSON(value?: MonitoredObjectGroupReplaceAssetsUsers | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'monitored_objects': value.monitoredObjects,
        'users': value.users,
    };
}


